var stores = {
	auchan: {
		name: 'Auchan',
		url: 'auchan',
		buy1_title: 'Cumpără',
		buy1_text: '<div class="stores-2020-line">Staropramen de </div><div class="stores-2020-line">minimum 14 lei </div>',
		buy2_title: 'Înscrie',
		buy2_text: '<div class="stores-2020-line">numărul bonului </div><div class="stores-2020-line">fiscal pe site-ul </div><div class="stores-2020-line">oamenisigusturi.ro/ </div><div class="stores-2020-line">gustul-intalnirilor/ </div><div class="stores-2020-line">auchan </div>',
		buy3_title: 'Poți câștiga',
		buy3_text: '<div class="stores-2020-line">prin tragere la sorți </div><div class="stores-2020-line">unul dintre premiile </div><div class="stores-2020-line">campaniei </div>',
		prizes1_title: 'Premii săptămânale',
		prizes1_text: '<large>100x</large> voucher cumpărături Auchan <small>(valoare 200 lei)</small>',
		prizes2_title: 'Premii lunare',
		prizes2_text: '<large>10x</large> aparat foto instant <small>(card cadou F64 valoare 1000 lei)</small>',
		store_id: '4',
		start_date: '01/07/2020',
		end_date: '28/07/2020',
		campaign: 'bonuri'
	},
	carrefour: {
		name: 'Carrefour',
		url: 'carrefour',
		buy1_title: 'Cumpără',
		buy1_text: '<div class="stores-2020-line">Staropramen de </div><div class="stores-2020-line">minimum 14 lei </div>',
		buy2_title: 'Înscrie',
		buy2_text: '<div class="stores-2020-line">numărul bonului </div><div class="stores-2020-line">fiscal pe site-ul </div><div class="stores-2020-line">oamenisigusturi.ro/ </div><div class="stores-2020-line">gustul-intalnirilor/ </div><div class="stores-2020-line">carrefour </div>',
		buy3_title: 'Poți câștiga',
		buy3_text: '<div class="stores-2020-line">prin tragere la sorți </div><div class="stores-2020-line">unul dintre premiile </div><div class="stores-2020-line">campaniei </div>',
		prizes1_title: 'Premii săptămânale',
		prizes1_text: '<large>100x</large> voucher cumpărături Carrefour ONLINE <small class="inline">(valoare 200 lei)</small>',
		prizes2_title: 'Premii lunare',
		prizes2_text: '<large>3x</large> card cadou Carrefour ONLINE <small>(valoare 2000 lei)</small>',
		store_id: '2',
		start_date: '06/07/2020',
		end_date: '05/08/2020',
		campaign: 'bonuri'
	},
	cora: {
		name: 'Cora',
		url: 'cora',
		buy1_title: 'Cumpără',
		buy1_text: '<div class="stores-2020-line">Staropramen de </div><div class="stores-2020-line">minimum 14 lei </div>',
		buy2_title: 'Înscrie',
		buy2_text: '<div class="stores-2020-line">numărul bonului/facturii </div><div class="stores-2020-line">fiscale pe site-ul </div><div class="stores-2020-line">oamenisigusturi.ro/ </div><div class="stores-2020-line">gustul-intalnirilor/ </div><div class="stores-2020-line">cora </div>',
		buy3_title: 'Poți câștiga',
		buy3_text: '<div class="stores-2020-line">prin tragere la sorți </div><div class="stores-2020-line">unul dintre premiile </div><div class="stores-2020-line">campaniei </div>',
		prizes1_title: 'Premii săptămânale',
		prizes1_text: '<large>50x</large> voucher cumpărături ALTEX <small>(valoare 200 lei)</small>',
		prizes2_title: 'Premii lunare',
		prizes2_text: '<large>2x</large> fotoliu relaxare <small>(card cadou Vivre valoare 1000 lei)</small>',
		store_id: '3',
		start_date: '01/07/2020',
		end_date: '31/07/2020',
		campaign: 'bonuri'
	},
	kaufland: {
		name: 'Kaufland',
		url: 'kaufland',
		buy1_title: 'Cumpără',
		buy1_text: '<div class="stores-2020-line">Staropramen de </div><div class="stores-2020-line">minimum 14 lei </div>',
		buy2_title: 'Înscrie',
		buy2_text: '<div class="stores-2020-line">numărul bonului </div><div class="stores-2020-line">fiscal pe site-ul </div><div class="stores-2020-line">oamenisigusturi.ro/ </div><div class="stores-2020-line">gustul-intalnirilor/ </div><div class="stores-2020-line">kaufland </div>',
		buy3_title: 'Poți câștiga',
		buy3_text: '<div class="stores-2020-line">prin tragere la sorți </div><div class="stores-2020-line">unul dintre premiile </div><div class="stores-2020-line">campaniei </div>',
		prizes1_title: 'Premii săptămânale',
		prizes1_text: '<large>100x</large> voucher cumpărături Jysk <small>(valoare 200 lei)</small>',
		prizes2_title: 'Premii lunare',
		prizes2_text: '<large>10x</large> grătar electric <small>(card cadou Kitchen Shop valoare 1000 lei)</small>',
		store_id: '1',
		start_date: '01/07/2020',
		end_date: '31/07/2020',
		campaign: 'bonuri'
	},
	megaimage: {
		name: 'Mega Image',
		url: 'megaimage',
		buy1_title: 'Cumpără',
		buy1_text: '<div class="stores-2020-line">Staropramen de </div><div class="stores-2020-line">minimum 14 lei </div>',
		buy2_title: 'Înscrie',
		buy2_text: '<div class="stores-2020-line">numărul bonului </div><div class="stores-2020-line">fiscal pe site-ul </div><div class="stores-2020-line">oamenisigusturi.ro/ </div><div class="stores-2020-line">gustul-intalnirilor/ </div><div class="stores-2020-line">megaimage </div>',
		buy3_title: 'Poți câștiga',
		buy3_text: '<div class="stores-2020-line">prin tragere la sorți </div><div class="stores-2020-line">unul dintre premiile </div><div class="stores-2020-line">campaniei </div>',
		prizes1_title: 'Premii săptămânale',
		prizes1_text: '<large>100x</large> voucher cumpărături AVSTORE <small>(valoare 200 lei)</small>',
		prizes2_title: 'Premii lunare',
		prizes2_text: '<large>2x</large> videoproiector portabil Nebula <small>(card cadou eMAG valoare 2500 lei)</small>',
		store_id: '5',
		start_date: '01/07/2020',
		end_date: '31/07/2020',
		campaign: 'bonuri'
	},
	mp: {
		name: 'Magazine de proximitate',
		url: 'mp',
		buy1_title: 'Cumpără',
		buy1_text: '<div class="stores-2020-line">orice produs </div><div class="stores-2020-line">Staropramen </div>',
		buy2_title: 'Răzuiește',
		buy2_text: '<div class="stores-2020-line">talonul și vezi </div><div class="stores-2020-line">dacă ai câștigat </div><div class="stores-2020-line">un premiu instant </div>',
		buy3_title: 'Înscrie codul',
		buy3_text: '<div class="stores-2020-line">de pe talon prin SMS </div><div class="stores-2020-line">la 1883 sau pe site-ul </div><div class="stores-2020-line">oamenisigusturi.ro </div><div class="stores-2020-line">și poți câștiga </div><div class="stores-2020-line">săptămânal prin </div><div class="stores-2020-line">tragere la sorți </div>',
		prizes1_title: 'Premii instant',
		prizes1_text: '',
		prizes2_title: 'Premii săptămânale',
		prizes2_text: '',
		store_id: '',
		start_date: '01/06/2020',
		end_date: '15/08/2020',
		campaign: 'offtrade'
	},
	non_sd: {
		name: 'Locații ce comercializează produse Bergenbier SA',
		url: 'non-sd',
		buy1_title: 'Comandă',
		buy1_text: '<div class="stores-2020-line">orice Staropramen </div><div class="stores-2020-line">la sticlă sau draft </div>',
		buy2_title: 'Răzuiește',
		buy2_text: '<div class="stores-2020-line">talonul și vezi </div><div class="stores-2020-line">dacă ai câștigat </div><div class="stores-2020-line">un premiu instant </div>',
		buy3_title: 'Înscrie',
		buy3_text: 'codul de pe talon și numărul bonului fiscal prin SMS la 1855 sau pe site-ul oamenisigusturi.ro și poți câștiga săptămânal prin tragere la sorți',
		prizes1_title: 'Premii instant',
		prizes1_text: '',
		prizes2_title: 'Premii săptămânale',
		prizes2_text: '',
		store_id: '',
		start_date: '01/06/2020',
		end_date: '15/08/2020',
		campaign: 'ontrade'
	},
	sd: {
		name: 'Locații partenere Bergenbier SA',
		url: 'sd',
		buy1_title: 'Comandă',
		buy1_text: '<div class="stores-2020-line">orice Staropramen </div><div class="stores-2020-line">la sticlă sau draft </div>',
		buy2_title: 'Înscrie',
		buy2_text: '<div class="stores-2020-line">codul de pe talon </div><div class="stores-2020-line">prin SMS la 1855 </div><div class="stores-2020-line">sau pe site-ul </div><div class="stores-2020-line">oamenisigusturi.ro </div>',
		buy3_title: 'Poți câștiga',
		buy3_text: '<div class="stores-2020-line">săptămânal prin </div><div class="stores-2020-line">tragere la sorți </div>',
		prizes1_title: 'Premii săptămânale',
		prizes1_text: '<large>90x</large> Aparat Polaroid <small>(10 pe săptămână)</small>',
		prizes2_title: '',
		prizes2_text: '<large>90x</large> Rucsac picnic <small>(10 pe săptămână)</small>',
		store_id: '',
		start_date: '01/06/2020',
		end_date: '15/08/2020',
		campaign: 'ontrade'
	}
}, activeStore;


$(window).on('load', function(){
	TweenMax.to('.preloader', 0.5, {opacity:0, display:'none', ease: Power2.easeOut});

	if ($('#stores-2020-box').data('store')){
		$(".stores-2020-stores").find('a[data-store="'+$('#stores-2020-box').data('store')+'"]').trigger('click');
	}

});

$(document).ready(function(){

	var today = new Date($('#stores-2020-box').data('today'));

	function showStore(store){

		$('#buy1_title').html(stores[store].buy1_title);
		$('#buy1_text').html(stores[store].buy1_text);
		$('#buy2_title').html(stores[store].buy2_title);
		$('#buy2_text').html(stores[store].buy2_text);
		$('#buy3_title').html(stores[store].buy3_title);
		$('#buy3_text').html(stores[store].buy3_text);

		$('input[name=store_id]').val(stores[store].store_id);
		$('input[name=campaign]').val(stores[store].campaign);

		$('#prizes1_title').html(stores[store].prizes1_title);
		if (stores[store].prizes1_text) {
			$('#prizes1_text').html(stores[store].prizes1_text).show();
		} else {
			$('#prizes1_text').html('').hide();
		}
		$('#prizes1_image').attr('src','/themes/oamenisigusturi/img/stores-2020/prizes-'+stores[store].url+'-1.png');

		$('#prizes1_box #prizes2_image, #prizes1_box #prizes2_text').remove();
		if (stores[store].prizes2_title) {
			$('#prizes2_title').html(stores[store].prizes2_title);
			$('#prizes2_title, #prizes2_box').show();
		} else {
			$('#prizes2_title, #prizes2_box').hide();
			$('#prizes1_box').append($('#prizes2_box').html());
		}

		if (stores[store].prizes2_text) {
			$('#prizes2_text').html(stores[store].prizes2_text).show();
		} else {
			$('#prizes2_text').html('').hide();
		}
		$('#prizes2_image').attr('src','/themes/oamenisigusturi/img/stores-2020/prizes-'+stores[store].url+'-2.png');

		$('.stores-2020-screen').removeClass('active').removeAttr('style');
		$('.stores-2020-screen-1').addClass('active');

		$('#stores-2020-regulament, #stores-2020-regulament-checkbox').attr('href','/files/Regulament-Staropramen_Viata-pe-gustul-tau_'+stores[store].url+'.pdf');

		var startDate = stores[store].start_date.split('/');
		var endDate = stores[store].end_date.split('/');

		var endD = today;
		if ( today > new Date(endDate[2]+'-'+endDate[1]+'-'+endDate[0]+' 23:59:59') ) {
			endD = stores[store].end_date;
			$('#perioada').html('Campania s-a încheiat!<br>Vă invităm să participați la campaniile noastre viitoare!').show();
			$('#form-button').hide();
			$('#stores-2020-regulament').parent().show();
		} else if ( today >= new Date(startDate[2]+'-'+startDate[1]+'-'+startDate[0]) ) {

			$('.stores-2020-form').removeClass('active');
			if ( stores[store].store_id ) {

				$('#stores-2020-form').addClass('active');
				if ($('.datepicker').data("DateTimePicker")){
					$('.datepicker').data("DateTimePicker").destroy();
				}
				$('.datepicker').datetimepicker({
					format: 'DD/MM/YYYY',
					locale: moment().locale('ro'),
					minDate: moment(stores[store].start_date, "DD/MM/YYYY"),
					maxDate: moment(endD, "DD/MM/YYYY"),
					dayViewHeaderFormat: 'MMMM YYYY',
					useCurrent: true,
					tooltips: {
						today: 'Astăzi',
						clear: 'Șterge selecția',
						close: 'Închide calendarul',
						selectMonth: 'Alege luna',
						prevMonth: 'Luna anterioară',
						nextMonth: 'Luna următoare',
						selectYear: 'Alege anul',
						prevYear: 'Anul anterior',
						nextYear: 'Anul următor',
						selectDecade: 'Alege deceniul',
						prevDecade: 'Deceniul anterior',
						nextDecade: 'Deceniul următor',
						prevCentury: 'Secolul anterior',
						nextCentury: 'Secolul următor'
					}
				});

				$('#showForm').text('Înscrie bonul fiscal');

			} else {
				$('#stores-2020-codes').addClass('active');
				$('#showForm').text('Înscrie un cod');
			}

			$('#perioada').text('').hide();
			$('#form-button').show();
			$('#stores-2020-regulament').parent().show();

		} else {
			$('#stores-2020-regulament').parent().hide();
			$('#perioada').text('Campania va începe în curând.').show();
			$('#form-button').hide();
		}

		$('#storeModal').modal({
			keyboard: false,
			backdrop: 'static'
		});

	}

	function showForm(){
		document.getElementById("stores-2020-form").reset();
		document.getElementById("stores-2020-codes").reset();

		$('.stores-2020-screen.active').slideUp().css('display','block').removeClass('active');
		$('#stores-2020--form').slideDown(function(){
			$('.stores-2020-screen').removeAttr('style');
		}).addClass('active');
	}

	$('#showForm,#resetForm').on('click', function(e){
		e.preventDefault();
		showForm();
	});


	$('.stores-2020-stores:not(.stores-2020-stores--online) a').on('click', function(e){
		e.preventDefault();
		activeStore = $(this).data('store');
		showStore(activeStore);
	});

	$("form.stores-2020-form").on('submit', function(e){
		e.preventDefault();
		if($(this).data('submitting'))
			return false; //double submit

		$('.form-group', this).removeClass('has-error');
		$('.form-group span.help-block', this).remove();
		$(this).data('submitting', true).addClass('submitting');
		$('button[type=submit]', this).button('loading');
		// $('button[type=submit] span.submit-label', this).text('Se trimite...');

    	var acum = window.location.search.replace(/^\?acum=/, "&acum="); //dev only

		$.ajax({
			type: $(this).attr('method'),
			url: $(this).attr('action'),
			data: $(this).serialize() + acum,
			context: this,
			success: function(data){
				//console.log("succ:", data);
				 if (window.ga) {
				 	ga('send', 'pageview', '/gustul-intalnirilor/'+stores[activeStore].url+'/succes');
				 }

				 /* window.dataLayer = window.dataLayer || [];
				  window.dataLayer.push({
					  'event': 'SMS2020Success'
				  });*/
				document.getElementById("stores-2020-form").reset();
				document.getElementById("stores-2020-codes").reset();
				$('.stores-2020-message').html(data.message);

				$('.stores-2020-screen.active').slideUp().css('display','block').removeClass('active');
				$('#stores-2020--message').slideDown(function(){
					$('.stores-2020-screen').removeAttr('style');
				}).addClass('active');

			},
			error: function(xhr) {
				$('button[type=submit] span.submit-label', this).text('Trimite');
				if(xhr.status == 422) {
          var errors  = xhr.responseJSON.errors || xhr.responseJSON || [];
          for (var field in errors) {
            // console.log(field);
            $('*[name=' + field + '], input[name=' + field + ']+label', this)
                .parents('.form-group:first').addClass('has-error')
                .append(
                    function () {
                      $errors = "";
                      for (var err in errors[field])
                        $errors += '<span class="help-block">' + errors[field][err] + '</span>';
                      return $errors;
                    }
                );
          }
				} else if(xhr.status == 403) {
					console.log(xhr);
				}
			},
			complete: function(xhr) {
				$(this).data('submitting', false).removeClass('submitting');
				$('button[type=submit]',this).button('reset');
			}
		});
	});

	$('#closeModal').on('click', function(e){
		$('#storeModal').modal('hide');
	});

});
